import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import LeftSidebar from "../components/LeftSidebar.tsx";
import BottomNav from "../components/BottomNav.tsx";
import DotsBackground from "../components/DotsBackground.tsx";
import { coursesData } from "../data/courses/courseData.ts";
import { getUserData } from "../utils/userStorage.ts";
import { useNavigate } from "react-router-dom";
import { FaRegSquareCheck } from "react-icons/fa6";

const AddCoursePage = () => {
  const [currentSection, setCurrentSection] = useState("Tambah Kursus");
  const [courses, setCourses] = useState(coursesData);
  const navigate = useNavigate();

  const handleCourseClick = (idx: number) => {
    if (courses[idx].label === "Batak Toba") {
      if (courses[idx].active) {
        navigate("/learn");
      } else {
        setCourses((prev) =>
          prev.map((c, i) => (i === idx ? { ...c, active: true } : c))
        );
      }
    } else {
      setCourses((prev) =>
        prev.map((c, i) => (i === idx ? { ...c, active: true } : c))
      );
      setTimeout(() => {
        alert(`Kursus ${coursesData[idx].label} Segera Datang!`);
        setCourses((prev) =>
          prev.map((c, i) => (i === idx ? { ...c, active: false } : c))
        );
      }, 200);
    }
  };

  const availableCourses = courses.filter((c) => c.active);
  const comingSoonCourses = courses.filter((c) => !c.active);

  const [darkMode, setDarkMode] = useState(() => {
    const data = getUserData();
    return data?.meta?.darkMode ?? false;
  });

  useEffect(() => {
    const handleStorage = (e: StorageEvent) => {
      if (e.key === "galaxy_aksara_user_data") {
        const data = getUserData();
        setDarkMode(data?.meta?.darkMode ?? false);
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, []);

  // Responsive breakpoints
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
  const isDesktop = useMediaQuery({ minWidth: 1024 });

  return (
    <div
      className={`flex min-h-screen relative ${
        darkMode ? "bg-gray-900" : "bg-gray-100"
      }`}
    >
      <DotsBackground darkMode={darkMode} />
      {isDesktop && (
        <LeftSidebar
          currentSection={currentSection}
          setCurrentSection={setCurrentSection}
          darkMode={darkMode}
        />
      )}
      {isTablet && !isMobile && (
        <LeftSidebar
          currentSection={currentSection}
          setCurrentSection={setCurrentSection}
          darkMode={darkMode}
          compact
        />
      )}
      <main className="flex-1 flex flex-col items-center relative z-10 px-4 py-10">
        <h1
          className={`text-4xl font-bold mb-8 text-center ${
            darkMode ? "text-gray-100" : "text-gray-800"
          }`}
          style={{ fontFamily: "Feather Bold" }}
        >
          Pilih Kursus Bahasa Batak
        </h1>

        {/* Tersedia */}
        <div className="w-full max-w-5xl mb-2">
          <div className="flex items-center mb-2">
            <div
              className={`flex-1 border-t ${
                darkMode ? "border-gray-700" : "border-gray-300"
              }`}
            ></div>
            <span
              className={`mx-4 text-lg font-bold mb-2 ${
                darkMode ? "text-gray-200" : "text-gray-700"
              }`}
              style={{ fontFamily: "DIN Next Rounded" }}
            >
              Tersedia
            </span>
            <div
              className={`flex-1 border-t ${
                darkMode ? "border-gray-700" : "border-gray-300"
              }`}
            ></div>
          </div>
          <div
            className={`flex flex-wrap justify-center ${
              isMobile || isTablet ? "gap-2 mb-4" : "gap-6 mb-8"
            }`}
          >
            {availableCourses.map((course, idx) => (
              <button
                key={course.label}
                className={`relative flex flex-col items-center justify-center rounded-2xl border-2 transition ${
                  isMobile || isTablet ? "p-2 w-32 h-24" : "p-6 w-56 h-40"
                } shadow group focus:outline-none ${
                  darkMode
                    ? course.active
                      ? "bg-gray-800 border-lime-500"
                      : "bg-gray-800 border-gray-700 hover:border-blue-400"
                    : course.active
                    ? "bg-white border-lime-500"
                    : "bg-white border-gray-200 hover:border-blue-400"
                }`}
                onClick={() =>
                  handleCourseClick(
                    courses.findIndex((c) => c.label === course.label)
                  )
                }
              >
                {course.active && (
                  <span
                    className={`absolute ${
                      isMobile || isTablet ? "top-2 right-2" : "top-3 right-3"
                    } text-lime-500`}
                  >
                    <FaRegSquareCheck
                      className={isMobile || isTablet ? "w-5 h-5" : "w-7 h-7"}
                    />
                  </span>
                )}
                <span
                  className={`${
                    isMobile || isTablet ? "text-base mb-0.5" : "text-xl mb-1"
                  } font-base text-center ${
                    darkMode ? "text-gray-100" : "text-gray-800"
                  }`}
                  style={{ fontFamily: "Feather Bold" }}
                >
                  {course.label}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* Segera Hadir */}
        <div className="w-full max-w-5xl">
          <div className="flex items-center mb-2">
            <div
              className={`flex-1 border-t ${
                darkMode ? "border-gray-700" : "border-gray-300"
              }`}
            ></div>
            <span
              className={`mx-4 text-lg font-bold mb-2 ${
                darkMode ? "text-gray-200" : "text-gray-700"
              }`}
              style={{ fontFamily: "DIN Next Rounded" }}
            >
              Segera Hadir!
            </span>
            <div
              className={`flex-1 border-t ${
                darkMode ? "border-gray-700" : "border-gray-300"
              }`}
            ></div>
          </div>
          <div
            className={`flex flex-wrap justify-center ${
              isMobile ? "gap-2 mb-4" : "gap-6 mb-8"
            }`}
          >
            {comingSoonCourses.map((course, idx) => (
              <button
                key={course.label}
                className={`relative flex flex-col items-center justify-center rounded-2xl border-2 transition ${
                  isMobile || isTablet ? "p-2 w-32 h-24" : "p-6 w-56 h-40"
                } shadow group focus:outline-none cursor-not-allowed ${
                  darkMode
                    ? "bg-gray-800 border-gray-700"
                    : "bg-white border-gray-200"
                }`}
                type="button"
                disabled
                tabIndex={-1}
                aria-disabled="true"
                style={{
                  pointerEvents: "none",
                }}
              >
                <span
                  className={`${
                    isMobile || isTablet ? "text-base mb-0.5" : "text-xl mb-1"
                  } font-base text-center ${
                    darkMode ? "text-gray-400" : "text-gray-500"
                  }`}
                  style={{ fontFamily: "Feather Bold" }}
                >
                  {course.label}
                </span>
              </button>
            ))}
          </div>
        </div>
      </main>
      {/* Bottom Nav (mobile only) */}
      {isMobile && (
        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100vw",
            zIndex: 30,
          }}
        >
          <BottomNav
            currentSection={currentSection}
            setCurrentSection={setCurrentSection}
            darkMode={darkMode}
          />
        </div>
      )}
    </div>
  );
};

export default AddCoursePage;
